import { Button, Icon, Link, Row, Text, useAppPalette } from "@bridgesplit/ui";
import { useUserPoints, useLoopscaleWalletContext } from "@bridgesplit/abf-react";
import { POINTS_SLUG } from "app/constants";

import { NAV_BUTTON_HEIGHT } from "./constants";
import { Points } from "../common/util";

export function NavPoints() {
    const { getPointsAtTime, isLoading } = useUserPoints();
    const { textPrimary, secondary, secondaryBackground } = useAppPalette();

    const {
        data: { userWalletAddress: user }
    } = useLoopscaleWalletContext();

    if (isLoading || !user) return null;

    return (
        <Link to={POINTS_SLUG}>
            <Button
                height={NAV_BUTTON_HEIGHT}
                textProps={{
                    sx: { color: textPrimary, svg: { color: secondary }, overflow: "hidden" }
                }}
                sx={{ backgroundColor: secondaryBackground, minWidth: "120px", maxWidth: "max-content" }}
                color="secondary"
                variant="outlined"
            >
                <Icon type="points" />
                <Points getPoints={getPointsAtTime} />
            </Button>
        </Link>
    );
}

export function PointsNested() {
    const { getPointsAtTime, isLoading } = useUserPoints();
    const { hoverBackground } = useAppPalette();

    const {
        data: { userWalletAddress: user }
    } = useLoopscaleWalletContext();

    if (!user || isLoading) return null;

    return (
        <Link
            sx={{
                width: "100%",
                cursor: "pointer",
                "&:hover": {
                    backgroundColor: hoverBackground
                }
            }}
            to={POINTS_SLUG}
        >
            <Row tabIndex={0} spacing={1} sx={{ flexGrow: 1, px: 2, py: 1 }}>
                <Text color="caption">Rewards</Text>
                <Text color="secondary">
                    <Icon type="points" /> <Points getPoints={getPointsAtTime} />
                </Text>
            </Row>
        </Link>
    );
}
